import React from 'react';
import './Dashboard.css'
import DashboardLoanCard from './DashboardLoanCard.js'
import { useDashboard } from '../../Global/Index.js';
import Loader from '../Loader/Index.js';
import { toast } from 'react-toastify';

const Dashboard = React.memo(() => {
  const { data, isLoading } = useDashboard();

  if (data) {
    if (data?.response?.status == '503') {
      toast.warn(data?.response?.message);
    } else if (data?.response?.status == '419') {
      window.location.href = "/Session-Expired"
    } else if (data?.response?.status == '500') {
      toast.error('Something went wrong. Please try again later!');
    } else if (data?.response?.status == '401') {
      window.location.href = '/'
    }
  }

  if (isLoading) {
    return <Loader />;
  }

  // Extract loanList from the data
  const currentLoanList = data?.response?.data?.loanList || [];

  return (
    <>
      {
        currentLoanList.length === 0 ?
          <div className="dashboard_main">
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
              No Loan Available
            </div>
          </div> :
          <div className="dashboard_main">
            <div className="dashboard_dynamic">
              <h2 className="activeloandata">
                Sanctioned/Disbursed Loan <span className="activeloannumber">{currentLoanList.length}</span>
              </h2>
              {currentLoanList.map((loan, index) => (
                <DashboardLoanCard key={index + 1} className='Dashboard_loan_card' loandetail={loan} />
              ))}
            </div>
          </div>
      }
    </>
  );
});

export default Dashboard;